import { useState, type FormEvent } from 'react';
import { submitForm } from '@/lib/submitForm';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/db4rqg9rqll58fj4oalg';

export default function NewsletterForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    setStatus('loading');
    setMessage('');

    const outcome = await submitForm(form, SUBMIT_ADDR, 'website_alt');
    if (outcome.ok) {
      setStatus('success');
      setMessage('订阅成功！最新韩剧资讯将第一时间送达你的邮箱。');
      form.reset();
    } else {
      setStatus('error');
      setMessage(outcome.message || '提交失败，请稍后重试。');
    }
  };

  return (
    <div>
      <form id="newsletter-form" data-readdy-form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2">
        <input
          type="text"
          name="website_alt"
          className="subscribe-guard-field"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
        <input
          type="email"
          name="email"
          required
          placeholder="输入你的邮箱地址"
          className="flex-1 bg-white/10 border border-white/20 rounded-full px-4 py-2.5 text-sm text-white placeholder:text-white/50 outline-none focus:border-white/60 transition-colors"
        />
        <button
          type="submit"
          disabled={status === 'loading'}
          className="cursor-pointer whitespace-nowrap bg-accent-500 hover:bg-accent-600 disabled:opacity-60 text-white text-sm font-medium px-5 py-2.5 rounded-full transition-colors"
        >
          {status === 'loading' ? '提交中…' : '立即订阅'}
        </button>
      </form>
      {message && (
        <p className={`mt-2 text-xs ${status === 'success' ? 'text-accent-200' : 'text-primary-200'}`}>{message}</p>
      )}
    </div>
  );
}